var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.9079V5.72368H16V6.9079H13ZM14 12.6316L11.58 10.8553L12.3 9.9079L14.72 11.6842L14 12.6316ZM12.36 2.70395L11.64 1.75658L14 0L14.72 0.947369L12.36 2.70395ZM2.6 11.8421V8.68421H1.2C0.866667 8.68421 0.583333 8.56908 0.35 8.33882C0.116667 8.10855 0 7.82895 0 7.5V5.13158C0 4.80263 0.116667 4.52303 0.35 4.29276C0.583333 4.0625 0.866667 3.94737 1.2 3.94737H4.8L8.8 1.57895V11.0526L4.8 8.68421H3.8V11.8421H2.6ZM9.6 8.96053V3.67105C9.96 3.98684 10.25 4.37171 10.47 4.82566C10.69 5.27961 10.8 5.77632 10.8 6.31579C10.8 6.85526 10.69 7.35197 10.47 7.80592C10.25 8.25987 9.96 8.64474 9.6 8.96053Z",
    fill: "#FEE600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.961aba5212ebdda6541258f2aac68539.svg";
export { ForwardRef as ReactComponent };